import type { BaseGroupType } from "src/AngularJS/Models/group-type.model";
import type { FilteredGroups, GroupSelectorDTO, GroupSelectorPostObject } from "src/AngularJS/Reusables/group-selector.models";
import { FilterableGroupingDTO } from "src/app/reusables/group-view-by-selector/group-view-by-selector.component";
import { ClearViewUtils } from "../utils";
import { CvApiServiceBase } from "./cv-api-service-base";

export class GroupSelectorServiceBase {
    constructor(
        fromSharedService: boolean = false,
        private cvApiService?: CvApiServiceBase,
    ) {
        if (fromSharedService)
            return GroupSelectorServiceBase.getServiceBase();

        if (!cvApiService)
            this.cvApiService = CvApiServiceBase.getServiceBase();
    }

    static getServiceBase(): GroupSelectorServiceBase {
        return ClearViewUtils.getSharedService(GroupSelectorServiceBase, 'GroupSelectorServiceBase');
    }

    loadGroupSelector(pageName: string, groupType: BaseGroupType, toggleGroupData: boolean = false) {
        return this.cvApiService.get<GroupSelectorDTO>(`/api/v1/group-selector/${pageName}?groupType=${groupType}&toggleGroupData=${toggleGroupData}`);
    }

    saveGroupSelector(pageName: string, groupType: BaseGroupType, groupSelector: GroupSelectorPostObject, creatorId?: number) {
        let uri = `/api/v1/group-selector/${pageName}?groupType=${groupType}`;
        if (creatorId) 
            uri += `&creatorId=${creatorId}`;

        return this.cvApiService.post<GroupSelectorDTO>(uri, groupSelector);
    }

    saveSelectedToggle(pageName: string, groupType: BaseGroupType, value: number, toggleGroupData: boolean = false, filterableGroupingDTO?: FilterableGroupingDTO) {
        let url = `/api/v1/group-selector/${pageName}/selected-toggle?groupType=${groupType}&level=${value}&toggleGroupData=${toggleGroupData}`;
        if (filterableGroupingDTO) {
            url += `&filterableValueField=${filterableGroupingDTO.ValueField}`;
            url += `&filterableDisplayValueField=${filterableGroupingDTO.ValueDisplayField}`;
            url += `&filterableValueSource=${filterableGroupingDTO.ValueSourceReportingSet}`;
            url += `&filterableDisplayName=${filterableGroupingDTO.FilterableDisplayName}`;
        }

        return this.cvApiService.post(url);
    }

    loadFilteredGroups(pageName: string, groupType?: BaseGroupType, specificLevel?: number, toggleGroupData: boolean = false) {
        let uri = `/api/v1/group-selector/${pageName}/groups?toggleGroupData=${toggleGroupData}`;

        if (groupType != null) {
            uri += `&groupType=${groupType}`;
        }

        if (specificLevel != null) {
            uri += `&specificLevel=${specificLevel}`;
        }

        return this.cvApiService.get<{ [level: number]: FilteredGroups }>(uri);
    }

    async loadCompanyGroupTypeMaxLevels(): Promise<{ [groupType: number]: number }> {
        const response = await this.cvApiService.get<{ [groupType: number]: number }>('/api/v1/group-selector/group-type-max-levels');
        return response.data;
    }
}
